var map = {
	"./assistant_1.png": 59195,
	"./comparator_1.png": 5671,
	"./heatmap_1.png": 87023,
	"./history_1.png": 96883,
	"./learning_1.png": 76409,
	"./manager_1.png": 72430,
	"./nps_1.png": 96422,
	"./report_1.png": 96985,
	"./rps_1.png": 82890,
	"./settings_1.png": 17048,
	"./survey_1.png": 17805
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4585;